import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isCurrentUserAdmin } from '../utils/adminUtils';

// Environment variable to enable/disable waitlist
const WAITLIST_ENABLED = process.env.REACT_APP_WAITLIST_ENABLED === 'true' || false;

const RootRedirect = () => {
  const [authResolved, setAuthResolved] = useState(false);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const currentUser = useSelector(state => state.auth.currentUser);
  const authLoading = useSelector(state => state.auth.loading);

  // Phase 5 Fix: Wait for auth resolution before making routing decisions
  useEffect(() => {
    if (!authLoading) {
      // Small delay to ensure auth state is fully resolved
      const timer = setTimeout(() => {
        setAuthResolved(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [authLoading]);

  // Show loading while auth is resolving
  if (!authResolved) {
    return (
      <div className="flex items-center justify-center min-h-[100dvh]">
        <div className="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full border-green-500 border-t-transparent" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  // If waitlist is disabled, use original logic
  if (!WAITLIST_ENABLED) {
    return isAuthenticated ? (
      <Navigate to="/home" replace />
    ) : (
      <Navigate to="/login" replace />
    );
  }

  // Phase 5 Fix: Implement state-machine routing for waitlist
  if (isAuthenticated && currentUser?.email) {
    // Check for admin bypass first (requires resolved email)
    if (isCurrentUserAdmin(currentUser)) {
      return <Navigate to="/home" replace />;
    }
    // Regular authenticated users go to home; WaitlistGuard handles gating
    return <Navigate to="/home" replace />;
  }

  // If not authenticated and waitlist is enabled:
  // Send to /waitlist as the landing page for new visitors
  return <Navigate to="/waitlist" replace />;
};

export default RootRedirect;
